export const mainTableFields = [
    {
        'name': 'Number of Total Cattle',
        'cowState': 'totalCows',
        'buffaloState': 'totalBuffalo',
        'total': 'totalCattle',
        'input': 'text'
    },
    {
        'name': 'Number of active Cattle',
        'cowState': 'activeCows',
        'buffaloState': 'activeBuffalo',
        'total': 'activeCattle',
        'input': 'text'
    },
    {
        'name': 'Cattle Breed',
        'cowState': 'setCowBreed',
        'buffaloState': 'setBuffaloBreed',
        'total': 'NA',
        'input': 'select',
        NA: true,
        cowOptions: [
            'Hybrid', 'Local'
        ],
        buffaloOptions: [
            'Hybrid', 'Local'
        ]
    },
    {
        'name': 'Per Cattle/day milk production (in Liter)',
        'cowState': 'perDayCowMilkProduction',
        'buffaloState': 'perDayBuffaloMilkProduction',
        'total': 'perDayMilkProduction',
        'input': 'text',
    },
    {
        'name': 'Per day total cattle milk production',
        'cowState': 'cowMilkProduction',
        'buffaloState': 'buffaloMilkProduction',
        'total': 'totalMilkProduction',
        'input': 'text',
        disabled: true
    },
    {
        'name': 'Supply for Cooperative (%)',
        'cowState': 'supplyForCowCorp',
        'buffaloState': 'supplyForBuffaloCorp',
        NA: true,
        'total': 'supplyForCorp',
        'input': 'text'
    },
    {
        'name': 'Open Market Sale (%)',
        'cowState': 'cowMarketSale',
        NA: true,
        'buffaloState': 'buffaloMarketSale',
        'total': 'totalMarketSale',
        'input': 'text'
    },
    {
        'name': 'Per Ltr Selling Price- Cooperative',
        'cowState': 'perLtrCowSellCorp',
        NA: true,

        'buffaloState': 'perLtrBuffaloSellCorp',
        'total': 'perLtrTotalSellCorp',
        'input': 'text'
    },
    {
        'name': 'Per Ltr Selling Price- Market',
        NA: true,

        'cowState': 'perLtrCowSellMkt',
        'buffaloState': 'perLtrBuffaloSellMkt',
        'total': 'perLtrTotalSellMkt',
        'input': 'text'
    },
    {
        'name': 'Per Litre milk selling price (Avg) (Milk Union & Open Market)',
        'cowState': 'perLtrCowSellAvg',
        'buffaloState': 'perLtrBuffaloSellAvg',
        'total': 'perLtrTotalSellAvg',
        'input': 'text',
        NA: true,
        disabled: true
    },
    {
        'name': 'Per day gross income from cattle',
        'cowState': 'perDayCowGross',
        'buffaloState': 'perDayBuffaloGross',
        'total': 'perDayTotalGross',
        'input': 'text',
        disabled: true
    },
    {
        'name': 'Per month gross income from cattle',
        'cowState': 'perLtrCowSellGross',
        'buffaloState': 'perLtrBuffaloSellGross',
        'total': 'perLtrTotalSellGross',
        'input': 'text',
        disabled: true
    },
    // {
    //     'name': 'Cost of feed per month/cattle',
    //     'cowState': 'costOfCowFeed',
    //     'buffaloState': 'CostOfBuffaloFeed',
    //     'total': 'feedTotalCost',
    //     'input': 'text'
    // },
    {
        'name': 'Per Month Per Cattle Cost',
        'cowState': 'perMonthPerCowCost',
        'buffaloState': 'perMonthPerBuffaloCost',
        NA: true,
        'total': 'totalPerMonthPerCattleCost',
        'input': 'text',
        // disabled: true,
    },
    {
        'name': 'Total Cost of cattle per month',
        'cowState': 'totalCostOfCowPerMonth',
        'buffaloState': 'totalCostOfBuffaloPerMonth',
        'total': 'totalCostOfCattlePerMonth',
        'input': 'text',
        disabled: true,
    },
    {
        'name': 'Net Income for Month (As per Customer)',
        'cowState': 'cowNetIncomePerMonth',
        'buffaloState': 'buffaloNetIncomePerMonth',
        'total': 'totalNetIncomePerMonth',
        'input': 'text',
        disabled: true,
    },

]